import config from '../../config.js';
import products from '../../utils/products.js';
import fieldUtils from '../../utils/step.fields.utils.js';
//todo change labels

const secondOccupation = () => {
    return [
        {
            key: `occupation_1_type`,
        },
    ];
};

const drivers = (n) => {
    const result = [
        {...fieldUtils.driver_x_name(n)},
        {...fieldUtils.driver_x_date_of_birth(n)},
        {...fieldUtils.driver_x_relationship(n)},
        {...fieldUtils.driver_x_licence_type(n)},
        {...fieldUtils.driver_x_licence_date(n)},
        {...fieldUtils.driver_x_claims(n)},
        {...fieldUtils.driver_x_convictions(n)},
        {...fieldUtils.driver_x_points(n)},
        {...fieldUtils.driver_x_criminal_convictions(n)},
    ];

    if (n < config[products.fresh_web_car].drivers) {
        result.push({
            ...fieldUtils.driver_x_more(n),
            label: 'Are any additional drivers required on the policy?',
            children: drivers(n + 1),
            required_children: value => value === true,
        });
    }
    return result;
};
const claims = (driver, n) => {
    const result = [
        {...fieldUtils.claim_x_type(driver, n)},
        {...fieldUtils.claim_x_date(driver, n)},
    ];

    if (n < config[products.fresh_web_car].claims) {
        result.push({
            ...fieldUtils.claim_x_more(driver, n),
            children: claims(driver, n + 1),
            required_children: value => value === true,
        });
    }
    return result;
};
const convictions = (driver, n) => {
    const result = [
        {...fieldUtils.conviction_x_type(driver, n)},
        {
            ...fieldUtils.conviction_x_ban(driver, n),
            children: [{
                ...fieldUtils.conviction_x_points(driver, n),
                required_if: parent_value => !parent_value
            }]
        },
    ];

    if (n < config[products.fresh_web_car].mot_convictions) {
        result.push({
            ...fieldUtils.conviction_x_more(driver, n),
            children: convictions(driver, n + 1),
            required_children: value => value === true,
        });
    }
    return result;
};

const modifications = (n) => {
    const result = [
        {...fieldUtils.modification_x_type(n)},
    ];

    if (n < config[products.car].vehicle_modifications) {
        result.push({
            ...fieldUtils.modification_x_more(n),
            children: modifications(n + 1),
            required_children: value => value === true,
        });
    }
    return result;
};

const step_schema_car = [
    //Vehicle
    {
        key: 'vrm',
    },
    {
        key: 'make',
        required: true,
        skip_question: true,

    },
    {
        key: 'model',
        skip_question: true,
    },
    {
        key: 'year',
        required: true,
        skip_question: true,
    },
    {
        key: 'colour',
        skip_question: true,
    },
    {
        key: 'fuel',
        skip_question: true,
    },
    {
        key: 'engine',
        skip_question: true,
    },

    {
        key: 'value',
    },
    {
        key: 'impounded',
    },
    {
        key: 'owner',
        children: [
            {
                key: 'owner_since',
                required_if: parent_value => parent_value === true,
            },
        ],
    },
    {
        key: 'ncb_years_private',
    },
    {
        key: 'personal_miles',
    },
    {
        key: 'has_modifications_more',
        children: modifications(0),
        required_children: value => value === true,
    },
    //Driver
    {
        key: 'driver_details',
        info: 'Details',
        extra_children: [
            {
                key: 'title',
                variant: 'inline'
            },
            {key: 'first_name'},
            {key: 'last_name'}
        ]
    },
    {
        key: 'gender',
    },
    {
        key: 'telephone',
    },
    {
        key: 'email',
    },
    {
        key: 'date_of_birth',
    },
    {
        key: 'postcode',
    },
    {
        key: 'address1',
        skip_question: true,
    },
    {
        key: 'address2',
        skip_question: true,
    },
    {
        key: 'address3',
        skip_question: true,
    },
    {
        key: 'address4',
        skip_question: true,
    },
    {
        key: 'city',
        skip_question: true,
    },
    {
        key: 'uk_since',
        label: 'Has this driver been in the UK since birth?',
        children: [
            {
                key: 'uk_since_date',
                label: 'On what date did the driver move to the UK?',
                required_if: parent_value => parent_value === false,
            },
        ],
    },

    {
        key: 'licence_type',
        label: `What type of licence does the driver hold?`,
    },
    {
        key: 'licence_date',
        label: `When was the driving licence issued?`,
    },
    {
        key: 'employment_status',
        children: [
            {
                key: 'occupation_student_living_at_home',
                required_if: parent_value => parent_value === 'student',
            },
            {
                label: `What is the driver's primary occupation?`,
                key: 'occupation_0_type',
                required_if: parent_value => parent_value === 'employed' || parent_value === 'self employed',
            },
            {
                key: 'occupation_0_more',
                label: 'Does the driver have a secondary occupation?',
                children: secondOccupation(),
                required_children: value => value === true,
                required_if: parent_value => parent_value === 'employed' || parent_value === 'self employed',
            },
        ],
    },
    {
        key: 'has_mot_convictions',
        label: 'Has the driver received any motoring convictions in the last 5 years?',
        children: convictions(`Proposer's`, 0),
        required_children: value => value === true,
        value: null
    },
    {
        key: 'has_claims',
        label: 'Has the driver made any claims in the last 5 years?',
        children: claims('Proposer\'s', 0),
        required_children: value => value === true,
        value: null
    },
    {
        key: 'has_criminal_convictions',
    },
    {
        key: 'has_another_driver_more',
        label: 'Are any additional drivers required on the policy?',
        children: drivers(0),
        required_children: value => value === true,
    },
    //policy
    {
        key: 'cover_date',
    },
    {
        key: 'cover_type',
    },
    {
        key: 'previous_policy_cancelled',
        label: 'Does the driver had any previously cancelled/voided insurance policy?',
    },
    {
        key: 'black_box',
    },
    {
        key: 'marketing',
        extra_children: [
            {key: 'marketing_phone'},
            {key: 'marketing_email'},
            {key: 'marketing_sms'},
        ],
    },
    {
        key: 'end',
    },
];
export default step_schema_car;
